// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__HC18v","checkboxContainer":"Checkbox_checkboxContainer__ApqBG"};